<mat-dialog-content class="p-0 m-0">
  <div class="join-dialog">
    <div mat-dialog-close class="title-dialog text-end">
      <svg xmlns="http://www.w3.org/2000/svg" width="40" height="40" viewBox="0 0 40 40">
        <g id="close-ic" transform="translate(-1173 -172)">
          <circle id="circle" cx="20" cy="20" r="20" transform="translate(1173 172)" fill="#fbfbfc" />
          <path id="close-ic-2" data-name="close-ic"
            d="M209,306.662l-4.986,4.986a1.175,1.175,0,1,1-1.662-1.662L207.338,305l-4.986-4.986a1.175,1.175,0,1,1,1.662-1.662L209,303.338l4.986-4.986a1.175,1.175,0,1,1,1.662,1.662L210.662,305l4.986,4.986a1.175,1.175,0,1,1-1.662,1.662Z"
            transform="translate(984 -113)" fill="#8479ac" />
        </g>
      </svg>
    </div>
    <div class="confirm_img text-center">
      <img src="assets/images/icons/join.svg" alt="" srcset="">
      <h3 class="head">{{"Auction Item.Join this auction?"|translate}}</h3>
      <p class="txt">
        {{"Auction Item.KeepInMindThatOnceYouJoinThisAuction"|translate}}
      </p>
    </div>


  </div>
</mat-dialog-content>

<mat-dialog-actions align="center">
  <div class="actions-join text-center">
    <button [disabled]="loading" mat-dialog-close class="btn  cancel">{{"Auction Item.Cancel"|translate}}</button>
    <button [disabled]="loading" (click)="join()" class="btn btn-primary confirm">{{"Auction Item.Join Auction"|translate}}

      <span *ngIf="loading" class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
    </button>
  </div>
</mat-dialog-actions>
